import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { Platform } from 'src/app/core/contracts/models/platform';
import { CargosService } from 'src/app/core/services/api/cargos.service';
import { Swal2 } from 'src/app/core/utils/swal2.util';

@Component({
  selector: 'app-cargos-form',
  templateUrl: './cargos-form.component.html',
  styleUrls: ['./cargos-form.component.scss']
})
export class CargosFormComponent implements OnInit {
  public loading:boolean=false;

  platform: Platform = {
    id: 0,
    descripcion: '',
    backgroundColor: '',
    textColor: ''
  };

  myForm = this.formBuilder.group({
    descripcion: new FormControl<string|null>(null,[Validators.required]) 
  });

  title: string = 'Crear Cargo';
  disabled: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private cargosService: CargosService,
    public dialogRef: MatDialogRef<CargosFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Platform,
    private swal: Swal2
  ) {
    if (data) {
      this.disabled = true;
      this.myForm.controls.descripcion.setValue(data.descripcion);
      this.title = 'Editar Cargo';
    }
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.platform.descripcion = this.myForm.controls.descripcion.value
    let observable:Observable<any>|undefined=undefined
    if (this.data) {
      this.platform.id = this.data.id;
     observable= this.cargosService.update(this.platform)
    } else {
     observable=this.cargosService.create(this.platform)
    }
    this.loading = true;
    observable.subscribe((response: any) => {
      this.dialogRef.close(response);
      this.loading = false;
      this.swal.showToast(response.message, 'success')
    }, error => {
      if (error.status === 400) {
        this.errors(error);
      }
      this.loading = false;
    });
  }

  errors(error) {
    if (error.error.errors.descripcion) {
      this.swal.showToast(error.error.errors.descripcion[0], 'error')
    }
  }


}
